import {Container, Grid, MenuItem, Snackbar, TableBody, TableHead, TextField} from "@mui/material";
import React, {useEffect, useState} from "react";
import {
    StyledAlert, StyledButtonBlack, StyledButtonContainer,
    StyledButtonOrange,
    StyledTable,
    StyledTableBodyRow, StyledTableCell,
    StyledTableCellHeader,
    StyledTableHeadRow
} from "../../../styles/MyStyles";
import dayjs from "dayjs";
import {GetEnumValueName} from "../../../logic/EnumHelper";
import {
    GetCryptoAmountExecutedAsSting,
    GetCryptoAmountRequestedAsSting, GetExecutedPricesSting,
    GetRequestedPricesSting
} from "../../../logic/OrderVolumeHelper";
import {useNavigate} from "react-router-dom";
import {GetCookieInfo} from "../../../logic/CookieManager";
import {GetClientViewName} from "../../../logic/ClientNameHelper";
import {GetClients} from "../../../logic/DataProvider";
import {GetOrderTitle} from "../../../logic/EntityTitleHelper";
import {GetLookupValueName} from "../../../logic/LookupHelper";
import * as ConfirmationDownloader from "../../../logic/ConfirmationDownloader";

const LastTradesPage = () => {
    const navigate = useNavigate();
    const [clients, setClients] = useState([]);
    const [trades, setTrades] = useState([]);
    const [selectedClient, setSelectedClient] = useState('');
    const [snackbar, setSnackbar] = React.useState({
        open: false,
        vertical: 'top',
        horizontal: 'center',
        message: ''
    });

    const handleCloseSnackbar = () => {
        setSnackbar({ ...snackbar, open: false });
    };

    useEffect(() => {
        GetClients().then((clients) => setClients(clients));
        const fetchTrades = async () => {
            try {
                const tokenCookie = GetCookieInfo('nplt');
                const response = await fetch(`${process.env.REACT_APP_TRADES_URL}/last`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + tokenCookie.value,
                    },
                });
                if (response.ok) {
                    const data = await response.json();

                    data.data.sort((a, b) => {
                        const dateA = new Date(a.date);
                        const dateB = new Date(b.date);
                        return dateB - dateA;
                    });

                    setTrades(data.data);
                } else {
                    console.log('Fetch trades failed.');
                }
            } catch (error) {
                console.log('An error occurred:', error);
            }
        };
        fetchTrades();
    }, []);

    const editTrade = (contactId, tradeId) => {
        navigate(`/contacts/clients/${contactId}/trade/${tradeId}`);
    }

    const getClientsMenuItems = () => {
        let items = [<MenuItem key="" value="">All</MenuItem>];
        if (clients) {
            clients.forEach((elem) => {
                items.push(
                    <MenuItem key={elem.id} value={elem.id}>
                        {GetClientViewName(elem)}
                    </MenuItem>
                );
            });
        }
        return items;
    };

    const handleClientFilter = (event) => {
        setSelectedClient(event.target.value);
    };

    const filteredTrades = trades ? trades.filter(
        (trade) => (selectedClient === '' || trade.contactId === parseInt(selectedClient))
    ) : [];

    const handleGoBack = () => {
        navigate('/');
    };

    return (
        <Container sx={{ margin: '0.2rem', minWidth: '99%' }}>
            <Snackbar
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                open={snackbar.open}
                autoHideDuration={6000}
                onClose={handleCloseSnackbar}>
                <StyledAlert onClose={handleCloseSnackbar} severity="error" sx={{ width: '100%' }}>
                    {snackbar.message}
                </StyledAlert>
            </Snackbar>
            <Grid container spacing={2}>
                <Grid item xs={12} md={3}>
                    <TextField
                        select
                        label="Client"
                        value={selectedClient}
                        onChange={handleClientFilter}
                        margin="normal"
                        size="small"
                        fullWidth
                    >
                        {getClientsMenuItems()}
                    </TextField>
                </Grid>
                <Grid item xs={12} md={9} sx={{ textAlign: 'right' }}>
                    <StyledButtonContainer>
                        <StyledButtonOrange variant="contained" onClick={handleGoBack} margin="normal">
                            Back to dashboard
                        </StyledButtonOrange>
                    </StyledButtonContainer>
                </Grid>
                <Grid item xs={12}>
                    <StyledTable>
                        <TableHead>
                            <StyledTableHeadRow>
                                <StyledTableCellHeader columncount={9}>Date</StyledTableCellHeader>
                                <StyledTableCellHeader columncount={9}>Contact</StyledTableCellHeader>
                                <StyledTableCellHeader columncount={9}>Action</StyledTableCellHeader>
                                <StyledTableCellHeader columncount={9}>Crypto Amount</StyledTableCellHeader>
                                <StyledTableCellHeader columncount={9}>Price</StyledTableCellHeader>
                                <StyledTableCellHeader columncount={9}>Brokerage Fee</StyledTableCellHeader>
                                <StyledTableCellHeader columncount={9}>Transaction Fee</StyledTableCellHeader>
                                <StyledTableCellHeader columncount={9}>Fee Asset</StyledTableCellHeader>
                                <StyledTableCellHeader columncount={9}></StyledTableCellHeader>
                            </StyledTableHeadRow>
                        </TableHead>
                        <TableBody>
                            {filteredTrades && filteredTrades.map((trade) => (
                                <StyledTableBodyRow key={trade.id}
                                                    onClick={() => editTrade(trade.contactId, trade.id)}>
                                    <StyledTableCell>{dayjs(trade.date).toDate().toDateString()}</StyledTableCell>
                                    <StyledTableCell>{GetClientViewName(clients.find(e => e.id === trade.contactId))}</StyledTableCell>
                                    <StyledTableCell>{GetEnumValueName('orderAction', trade.action)}</StyledTableCell>
                                    <StyledTableCell>{trade.cryptoAmount}</StyledTableCell>
                                    <StyledTableCell>{trade.price}</StyledTableCell>
                                    <StyledTableCell>{trade.brokerageFee}</StyledTableCell>
                                    <StyledTableCell>{trade.transactionFee}</StyledTableCell>
                                    <StyledTableCell>{GetLookupValueName('asset', trade.feeAssetId)}</StyledTableCell>
                                    <StyledTableCell>
                                        <StyledButtonOrange
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                ConfirmationDownloader.GenerateTradeConfirmation(trade.id, snackbar, setSnackbar);
                                            }}>
                                            Confirmation
                                        </StyledButtonOrange>
                                    </StyledTableCell>
                                </StyledTableBodyRow>
                            ))}
                        </TableBody>
                    </StyledTable>
                </Grid>
            </Grid>
        </Container>
    );
};

export default LastTradesPage;